module.exports = __webpack_public_path__ + "img/wb_ef.226c548f.jpg";